import { useState, useEffect } from 'react';
import {objectHelpers} from '../../utils/helpers';
import {useEmployee} from '../user/useEmployee';

export const useIsEmployeeChanged = () => {
  const currentUser = useEmployee();
  const [company, setCompany] = useState(null);
  const [isChanged, setIsChanged] = useState(false);

  useEffect(() => {
    if (!objectHelpers.isEmptyObject(currentUser)) {
      const companyId = currentUser.company_id;
      if (company !== companyId) {
        if (company !== null) {
          setIsChanged(true);
        }
        setCompany(companyId);
      } else {
        setIsChanged(false);
      }
    } else {
      setIsChanged(false);
    }
  }, [currentUser, company]);

  return isChanged;
}

